<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Users") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      v-if="!show_page_detail"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title" style="color: white;">
              {{ $t("List of Users") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            table-header-color="primary"
            class="paginated-table table-striped table-hover"
          >
            <md-table-head>ID</md-table-head>
            <md-table-head>{{ $t("Name") }}</md-table-head>
            <md-table-head>{{ $t("License Number") }}</md-table-head>
            <md-table-head>{{ $t("Email") }}</md-table-head>
            <md-table-head
              class="check"
              v-if="
                usertype === USER_TYPE.ADMIN ||
                  usertype === USER_TYPE.ENTERPRISE ||
                  usertype === USER_TYPE.SUPER
              "
              >{{ $t("Super User") }}</md-table-head
            >
            <md-table-head class="check">{{ $t("Pilot") }}</md-table-head>
            <md-table-head class="check">{{ $t("Observer") }}</md-table-head>
            <md-table-head class="check">{{
              $t("Payload Operator")
            }}</md-table-head>
            <md-table-head class="check">{{ $t("View") }}</md-table-head>
            <md-table-head class="check">{{ $t("Edit") }}</md-table-head>

            <md-table-toolbar>
              <md-field>
                <label for="pages">{{ $t("Per page") }}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, position) in pagination.perPageOptions"
                    :key="position"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-field>
                <md-button
                  class="md-raised md-primary mt-4"
                  @click="showEditor(null)"
                >
                  {{ $t("Add") }}
                </md-button>
              </md-field>
            </md-table-toolbar>
            <!-- <md-table-row
              v-for="(item, position) in pilots"
              :key="position"
              :style="
                position === selectedPosition
                  ? 'background-color: lightgrey'
                  : ''
              "
              @click.native="showPageDetail(item, position)"
            > -->
            <md-table-row v-for="(item, position) in pilots" :key="position">
              <md-table-cell v-if="item.firstname.length > 0" md-label="ID">{{
                position + 1
              }}</md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('Name')"
                >{{ item.firstname }} {{ item.lastname }}</md-table-cell
              >
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('License Number')"
              >
                <label style="line-height: 52px">{{ item.license }}</label>
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.licenseFile"
                >
                  <a target="blank" :href="LICENSE_URL + item.licenseFile">
                    <md-icon>visibility</md-icon>
                  </a>
                </md-button>
              </md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('Email')"
                >{{ item.email }}</md-table-cell
              >
              <md-table-cell
                v-if="
                  (usertype === USER_TYPE.ADMIN ||
                    usertype === USER_TYPE.ENTERPRISE ||
                    usertype === USER_TYPE.SUPER) &&
                    item.firstname.length > 0
                "
                :md-label="$t('Super User')"
                class="check"
              >
                <md-icon v-if="item.superuser" class="">check</md-icon>
              </md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('Pilot')"
                class="check"
              >
                <md-icon v-if="item.pilot" class="">check</md-icon>
              </md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('Observer')"
                class="check"
              >
                <md-icon v-if="item.observer" class="">check</md-icon>
              </md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('Payload Operator')"
                class="check"
              >
                <md-icon v-if="item.payloadOperator" class="">check</md-icon>
              </md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('View')"
                class="check"
              >
                <md-button
                  class="md-just-icon md-simple md-primary"
                  @click="showPageDetail(item, position)"
                >
                  <md-icon>list_alt</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell
                v-if="item.firstname.length > 0"
                :md-label="$t('Edit')"
                class="check"
              >
                <md-button
                  class="md-just-icon md-simple md-primary"
                  @click="showEditor(position)"
                >
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              {{
                $t("Showing") +
                  (from + 1) +
                  " " +
                  $t("to") +
                  " " +
                  to +
                  " " +
                  $t("of") +
                  " " +
                  total +
                  " " +
                  $t("entries")
              }}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

    <div
      v-if="show_page_detail"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("User Details") }}</h4>
          </div>
          <br />
          <md-button
            class="md-primary"
            style="width:200px"
            @click="showPageDetail(null, null)"
            >Go Back</md-button
          >

          <!-- <md-button style="float: right;"
              class="md-primary"
              @click="showEditor(pilot)"
            >
              {{ $t("Edit") }}
            </md-button> -->
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-48 md-xsmall-size-100 md-size-53"
            >
              <md-list class="md-double-line">
                <md-subheader>{{ $t("Information") }}</md-subheader>
                <md-list-item>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("First Name") }}</label>
                        <md-input v-model="pilot.firstname" disabled></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Last Name") }}</label>
                        <md-input v-model="pilot.lastname" disabled></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Telephone") }}</label>
                        <md-input v-model="pilot.phone" disabled></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Email") }}</label>
                        <md-input v-model="pilot.email" disabled></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Super User") }}</label>
                        <md-input
                          v-model="pilot.superuser_text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Pilot") }}</label>
                        <md-input
                          v-model="pilot.pilot_text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Observer") }}</label>
                        <md-input
                          v-model="pilot.observer_text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-25">
                      <md-field>
                        <label>{{ $t("Payload Operator") }}</label>
                        <md-input
                          v-model="pilot.payloadOperator_text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div
                      v-if="usertype !== USER_TYPE.FREE && pilot.pilot"
                      class="md-layout-item md-small-size-100 md-size-35"
                    >
                      <md-field>
                        <label>{{ $t("License Number") }}</label>
                        <md-input v-model="pilot.license" disabled></md-input>
                      </md-field>
                    </div>
                    <div
                      v-if="usertype !== USER_TYPE.FREE && pilot.pilot"
                      class="md-layout-item md-small-size-100 md-size-35"
                    >
                      <md-field>
                        <label>{{ $t("License Type") }}</label>
                        <md-input
                          v-model="pilot.licenseType_text"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div
                      v-if="usertype !== USER_TYPE.FREE && pilot.pilot"
                      class="md-layout-item md-small-size-100 md-size-25"
                    >
                      <md-field>
                        <label>{{ $t("Recency Requirement (days)") }}</label>
                        <md-input v-model="pilot.threshold" disabled></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
                <br />
                <md-divider></md-divider>
                <md-subheader>{{ $t("Statistics") }}</md-subheader>
                <md-table
                  v-if="usertype !== USER_TYPE.FREE && pilot.pilot"
                  style="padding-left: 30px;"
                  table-header-color="primary"
                  class=""
                >
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Number of") }}<br />{{ $t("Missions (Created)") }}
                    <md-tooltip md-direction="top">
                      {{ $t("Number of total recorded flights") }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Number of") }}<br />{{ $t("Missions (Completed)") }}
                    <md-tooltip md-direction="top">
                      {{ $t("Number of completed flights") }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Flight hours") }}<br />{{ $t("Logged") }}
                    <md-tooltip md-direction="top">{{
                      $t("Total number of logged flight hours")
                    }}</md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Days since") }}<br />{{
                      $t("Last completed mission")
                    }}
                    <md-tooltip md-direction="top">
                      {{ $t("Number of days since last recorded flight") }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Status") }}
                    <md-tooltip md-direction="top">
                      {{ $t("Pilot Compliance with Recency Requirement") }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-row
                    v-for="(item, position) in pilots"
                    :key="position"
                  >
                    <md-table-cell
                      :md-label="$t('Missions (Created)')"
                      v-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          pilotHasAllMissions &&
                          item.email === pilot.email
                      "
                      >{{
                        item.pilot &&
                        pilotTotalMissionsAll &&
                        pilotTotalMissionsAll.find(
                          pilot => pilot._id.license === item.license
                        )
                          ? pilotTotalMissionsAll.find(
                              pilot => pilot._id.license === item.license
                            ).missions
                          : item.license
                          ? 0
                          : ""
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Missions (Created)')"
                      v-else-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          !pilotHasAllMissions &&
                          item.email === pilot.email
                      "
                      >{{ 0 }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Missions (Completed)')"
                      v-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          pilotHasMissions &&
                          item.email === pilot.email
                      "
                      >{{
                        item.pilot &&
                        pilotTotalMissions &&
                        pilotTotalMissions.find(
                          pilot => pilot._id.license === item.license
                        )
                          ? pilotTotalMissions.find(
                              pilot => pilot._id.license === item.license
                            ).missions
                          : item.license
                          ? 0
                          : ""
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Missions (Completed)')"
                      v-else-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          !pilotHasMissions &&
                          item.email === pilot.email
                      "
                      >{{ 0 }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Flight Hours (Logged)')"
                      v-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          pilotHasHours &&
                          item.email === pilot.email
                      "
                      >{{
                        item.pilot &&
                        pilotTotalHours &&
                        pilotTotalHours.find(
                          pilot => pilot._id.license === item.license
                        )
                          ? pilotTotalHours
                              .find(pilot => pilot._id.license === item.license)
                              .hours.toFixed(2)
                          : item.license
                          ? (0.0).toFixed(2)
                          : ""
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Flight Hours (Logged)')"
                      v-else-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          !pilotHasHours &&
                          item.email === pilot.email
                      "
                      >{{ (0.0).toFixed(2) }}</md-table-cell
                    >

                    <md-table-cell
                      :md-label="$t('Since last completed mission (days)')"
                      v-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          item.license === pilot.license
                      "
                      >{{
                        item.pilot &&
                        pilotCurrentDays &&
                        pilotCurrentDays.find(
                          pilot => pilot._id.license === item.license
                        )
                          ? daysSince(
                              pilotCurrentDays.find(
                                pilot => pilot._id.license === item.license
                              ).last_mission.$date
                            )
                          : item.pilot
                          ? "N/A"
                          : ""
                      }}</md-table-cell
                    >

                    <md-table-cell
                      :md-label="$t('Status')"
                      v-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          item.license === pilot.license &&
                          pilotCurrentDays &&
                          pilotCurrentDays.find(
                            pilot => pilot._id.license === item.license
                          ) &&
                          daysSince(
                            pilotCurrentDays.find(
                              pilot => pilot._id.license === item.license
                            ).last_mission.$date
                          ) < item.threshold
                      "
                    >
                      <md-button class="md-just-icon md-simple md-success">
                        <md-icon>verified_user</md-icon>
                        <md-tooltip md-direction="top">{{
                          $t("Good Standing")
                        }}</md-tooltip>
                      </md-button>
                    </md-table-cell>
                    <md-table-cell
                      :md-label="$t('Status')"
                      v-else-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          item.license === pilot.license &&
                          pilotCurrentDays &&
                          pilotCurrentDays.find(
                            pilot => pilot._id.license === item.license
                          ) &&
                          daysSince(
                            pilotCurrentDays.find(
                              pilot => pilot._id.license === item.license
                            ).last_mission.$date
                          ) >= item.threshold
                      "
                    >
                      <md-button
                        v-if="item.threshold"
                        class="md-just-icon md-simple md-danger"
                      >
                        <md-icon>warning</md-icon>
                        <md-tooltip md-direction="top">{{
                          $t("Pilot recency not met")
                        }}</md-tooltip>
                      </md-button>
                    </md-table-cell>
                    <md-table-cell
                      :md-label="$t('Status')"
                      v-else-if="
                        usertype !== USER_TYPE.FREE &&
                          item.pilot &&
                          item.license === pilot.license &&
                          !pilotCurrentDays.find(
                            pilot => pilot._id.license === item.license
                          )
                      "
                    >
                      <md-button
                        v-if="item.threshold"
                        class="md-just-icon md-simple md-danger"
                      >
                        <md-icon>warning</md-icon>
                        <md-tooltip md-direction="top">{{
                          $t("Pilot recency not available")
                        }}</md-tooltip>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <md-divider></md-divider>
                <br />
                <md-subheader v-if="pilot.pilot">{{
                  $t("Documents")
                }}</md-subheader>
                <md-list-item v-if="pilot.pilot" class="md-inset">
                  <div v-if="pilot.pilot" class="md-layout">
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30"
                    >
                      <md-icon class="">library_books</md-icon>
                      <div class="" style="display: contents;">
                        <span>&nbsp;&nbsp;{{ $t("Pilot License") }}</span>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35"
                    >
                      <div class="">
                        <md-button
                          class="md-primary"
                          style="width:150px"
                          :disabled="pilot.licenseFile === ''"
                        >
                          <a
                            target="blank"
                            :href="LICENSE_URL + pilot.licenseFile"
                            style="font-size : 12px;"
                            >{{ $t("VIEW FILE") }}</a
                          >
                        </md-button>
                      </div>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30"
                    ></div>
                  </div>
                </md-list-item>
                <br />
                <md-divider></md-divider>
                <br />
              </md-list>
            </div>

            <div
              class="md-layout-item md-medium-size-48 md-xsmall-size-100 md-size-43"
            >
              <md-list class="md-double-line">
                <md-subheader>
                  {{ $t("Training History") }} &nbsp;&nbsp;&nbsp;
                  <md-button
                    class="md-simple md-just-icon md-round"
                    @click="showTrainingEditorPilot(pilot)"
                  >
                    <md-icon>add</md-icon>
                  </md-button>
                </md-subheader>
                <md-table
                  style="padding-left: 30px;"
                  v-model="selectedPilotTraining"
                  class=""
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell
                      :md-label="$t('Timestamp')"
                      v-if="item.license === pilot.license"
                      >{{
                        new Date(item.timestamp.$date).toLocaleString("en-US")
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Details')"
                      v-if="item.license === pilot.license"
                      style="white-space: pre-wrap;"
                      >{{ item.details }}</md-table-cell
                    >
                  </md-table-row>
                </md-table>
                <br />
                <md-divider></md-divider>
                <br />
              </md-list>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <modal v-if="editing">
      <template slot="header">
        <md-button
          class="md-just-icon md-round modal-default-button"
          @click="closeEditor(true)"
          style="right: 20px; top: 20px;"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>people</md-icon>
            </div>
            <h4 class="title" style="text-align:left">
              {{ $t("User Details") }}
            </h4>
          </md-card-header>

          <md-card-content
            style="height: 400px; overflow-y: auto; padding: 10px;"
          >
            <div style="text-align:left">
              <md-checkbox
                v-model="pilot.superuser"
                v-if="
                  usertype === USER_TYPE.ADMIN ||
                    usertype === USER_TYPE.ENTERPRISE ||
                    usertype === USER_TYPE.SUPER
                "
                >{{ $t("Super User") }}</md-checkbox
              >
              <br />
              <md-checkbox v-model="pilot.pilot" @change="onPilotChange">{{
                $t("Pilot")
              }}</md-checkbox>
              <md-field
                v-if="
                  usertype === USER_TYPE.ADMIN ||
                    usertype === USER_TYPE.ENTERPRISE ||
                    usertype === USER_TYPE.SUPER
                "
                :class="[
                  {
                    'md-valid': !errors.has('threshold') && touched.threshold
                  },
                  { 'md-error': errors.has('threshold') }
                ]"
              >
                <label>{{ $t("Pilot Recency (days)") }}</label>
                <md-input
                  name="threshold"
                  data-vv-name="threshold"
                  :disabled="isPilotSel"
                  v-model="pilot.threshold"
                  required
                  v-validate="'required|between:10,100'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('threshold')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('threshold') && touched.threshold"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>
              <md-checkbox v-model="pilot.observer">{{
                $t("Observer")
              }}</md-checkbox>
              <br />
              <md-checkbox v-model="pilot.payloadOperator">{{
                $t("Payload Operator")
              }}</md-checkbox>
            </div>
            <md-field
              :class="[
                { 'md-valid': !errors.has('firstname') && touched.firstname },
                { 'md-error': errors.has('firstname') }
              ]"
            >
              <label>{{ $t("First Name") }}</label>
              <md-input
                name="firstname"
                data-vv-name="firstname"
                v-model="pilot.firstname"
                required
                v-validate="'required|min:2'"
                type="text"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('firstname')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('firstname') && touched.firstname"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <md-field
              :class="[
                { 'md-valid': !errors.has('lastname') && touched.lastname },
                { 'md-error': errors.has('lastname') }
              ]"
            >
              <label>{{ $t("Last Name") }}</label>
              <md-input
                name="lastname"
                data-vv-name="lastname"
                v-model="pilot.lastname"
                required
                v-validate="'required|min:2'"
                type="text"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('lastname')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('lastname') && touched.lastname"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <md-field
              :class="[
                { 'md-valid': !errors.has('license') && touched.license },
                { 'md-error': errors.has('license') }
              ]"
            >
              <label>{{ $t("Pilot Certificate Number") }}</label>
              <md-input
                name="license"
                data-vv-name="license"
                v-model="pilot.license"
                :required="pilot.pilot"
                :disabled="isPilotLic"
                v-validate="pilot.pilot ? 'required|min:10' : 'min:10'"
                type="text"
                @change="onPilotCertificateChange"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('license')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('license') && touched.license"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <div style="text-align: left">
              <md-radio v-model="pilot.licenseType" :value="0">{{
                $t("Basic")
              }}</md-radio>
              <md-radio v-model="pilot.licenseType" :value="1">{{
                $t("Advanced")
              }}</md-radio>
            </div>
            <div style="text-align:left">
              <md-button class="md-primary md-fileinput">
                <template>{{ $t("Upload License") }}</template>
                <input type="file" @change="onUploadLicense" />
              </md-button>
              <br />
              <label v-if="pilot.selectedFile != ''">{{
                pilot.selectedFile
              }}</label>
              <label v-else-if="pilot.licenseFile != ''">{{
                pilot.licenseFile
              }}</label>
              <br />
            </div>
            <br />
            <md-field
              :class="[
                { 'md-valid': !errors.has('phone') && touched.phone },
                { 'md-error': errors.has('phone') }
              ]"
            >
              <label>{{ $t("Telephone") }}</label>
              <md-input
                name="phone"
                data-vv-name="phone"
                v-model="pilot.phone"
                :required="pilot.pilot"
                v-validate="pilot.pilot ? 'required|min:17' : 'min:17'"
                type="text"
                v-mask="'+1 (###) ###-####'"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('phone')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('phone') && touched.phone"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <md-field
              :class="[
                { 'md-valid': !errors.has('email') && touched.email },
                { 'md-error': errors.has('email') }
              ]"
            >
              <label>{{ $t("Email") }}</label>
              <md-input
                name="email"
                data-vv-name="email"
                v-model="pilot.email"
                v-validate="'required|email'"
                required
                type="email"
                @change="onPilotEmailChange"
              />
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('email')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('email') && touched.email"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
          </md-card-content>
        </md-card>
      </template>
      <template slot="footer">
        <md-button
          style="margin-right: 50px;"
          class="md-raised md-primary mt-4"
          @click="validate"
          :disabled="
            !pilot.pilot &&
              !pilot.observer &&
              !pilot.payloadOperator &&
              !pilot.superuser
          "
          >{{ $t("Save") }}</md-button
        >
        <md-button
          v-if="isNew === false"
          class="md-default md-raised mt-4"
          @click="deletePilot"
          :disabled="isNew"
          >{{ $t("Delete") }}</md-button
        >
      </template>
    </modal>

    <modal v-if="editingTraining">
      <template slot="header">
        <md-button
          class="md-just-icon md-round modal-default-button"
          @click="closeTrainingEditor"
          style="right: 20px; top: 20px;"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>people</md-icon>
            </div>
            <h4 class="title" style="text-align:left">
              {{ $t("Pilot Training Report") }}
            </h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label>{{ $t("First Name") }}</label>
              <md-input
                name="firstname"
                v-model="firstname"
                disabled
                type="text"
              ></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("Last Name") }}</label>
              <md-input
                name="lastname"
                v-model="lastname"
                disabled
                type="text"
              ></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("License") }}</label>
              <md-input
                name="license"
                v-model="license"
                disabled
                type="text"
              ></md-input>
            </md-field>
            <md-field class="md-has-value">
              <label>{{ $t("Training Schedule") }}</label>
              <datetime
                input-class="md-input"
                type="datetime"
                v-model="trainingDate"
              ></datetime>
            </md-field>
            <md-field>
              <label>{{ $t("Details") }}</label>
              <md-textarea v-model="trainingDetails"></md-textarea>
            </md-field>
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button
          class="md-raised md-primary mt-4"
          :disabled="trainingDate === '' || trainingDetails === ''"
          @click="saveTraining"
          >{{ $t("Save") }}</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import { SlideYDownTransition } from "vue2-transitions";
import { Pagination } from "@/components";
import { mask } from "vue-the-mask";
import swal from "sweetalert2";
import { EventBus, LICENSE_URL } from "@/helpers";
import { threshold_pilot_days, USER_TYPE } from "@/const.js";
import moment from "moment";
import { router } from "@/main";

export default {
  $_veeValidate: {
    validator: "new"
  },
  directives: { mask },
  components: {
    Modal,
    SlideYDownTransition,
    Pagination
  },
  data() {
    return {
      currentSort: "pilotname",
      currentSortOrder: "desc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      isUpdated: false,
      show_page_detail: false,
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      LICENSE_URL: LICENSE_URL,
      USER_TYPE: USER_TYPE,
      responsive: false,
      errorMsg: "",
      pilot: {
        pilotposition: 0,
        firstname: "",
        lastname: "",
        pilotname: "",
        license: "",
        licenseType: -1,
        licenseType_text: "",
        licenseFile: "",
        fileType: "",
        licenseData: null,
        selectedFile: "",
        phone: "",
        email: "",
        pilot: false,
        threshold: threshold_pilot_days,
        observer: false,
        payloadOperator: false,
        superuser: false,
        pilot_text: "No",
        observer_text: "No",
        payloadOperator_text: "No",
        superuser_text: "No",
        pilotTotalMissions: [],
        pilotTotalMissionsAll: [],
        pilotMissions: 0,
        pilotMissionsAll: 0
      },

      editing: false,
      isNew: false,
      isPilot: false,
      isPilotSel: true,
      isPilotLic: false,
      position: 0,

      editingTraining: false,
      trainingDate: "",
      trainingDetails: "",
      selectedPosition: -1,
      selectedPilotTraining: [],

      touched: {
        firstname: false,
        lastname: false,
        license: false,
        phone: false,
        email: false,
        threshold: false
      }
    };
  },
  watch: {
    firstname() {
      this.touched.firstname = true;
    },
    lastname() {
      this.touched.lastname = true;
    },
    license() {
      this.touched.license = true;
    },
    phone() {
      this.touched.phone = true;
    },
    email() {
      this.touched.email = true;
    },
    threshold() {
      this.touched.threshold = true;
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = [];
      result = this.pilots;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },
  computed: {
    blur: function() {
      return this.editing;
    },
    ...mapMultiRowFields("setting", ["pilots", "pilotTraining"]),
    ...mapFields("setting", ["pilotQuantity"]),
    ...mapFields("auth", ["quantity", "plan_type", "email", "usertype"]),
    ...mapFields("stats", [
      "pilotHasMissions",
      "pilotHasAllMissions",
      "totalMissions",
      "totalHours",
      "pilotHasHours"
    ]),
    ...mapMultiRowFields("stats", [
      "pilotTotalMissions",
      "pilotTotalMissionsAll",
      "pilotTotalHours",
      "pilotCurrentDays"
    ]),
    queriedData() {
      let result = [];
      result = this.pilots;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length - 1
        : this.pilots.length - 1;
    }
  },
  methods: {
    showPageDetail(pilot, position) {
      if (pilot != null) {
        this.position = position;
        this.pilot.pilotposition = this.position;
        this.show_page_detail = true;
        this.pilot.email = pilot.email;
        this.pilot.firstname = pilot.firstname;
        this.pilot.lastname = pilot.lastname;
        this.pilot.pilotname = pilot.firstname + " " + pilot.lastname;
        this.pilot.license = pilot.license;
        this.pilot.pilot = pilot.pilot;
        this.pilot.phone = pilot.phone;
        this.pilot.threshold = pilot.threshold
          ? pilot.threshold
          : threshold_pilot_days;
        if (this.pilot.pilot) {
          this.pilot.pilot_text = "Yes";
          this.pilot.licenseType = pilot.licenseType;
          if (this.pilot.licenseType === 0) {
            this.pilot.licenseType_text = "Basic";
          } else if (this.pilot.licenseType === 1) {
            this.pilot.licenseType_text = "Advanced";
          } else {
            this.pilot.licenseType_text = "N/A";
          }
          this.pilot.licenseFile = pilot.licenseFile;
          if (this.pilot.licenseFile !== undefined) {
            this.pilot.licenseFile = pilot.licenseFile;
          } else {
            this.pilot.licenseFile = "";
          }
          if (this.$store.state.stats.pilotHasMissions) {
            this.pilot.pilotTotalMissions = this.$store.state.stats.pilotTotalMissions;
            //this.pilot.pilotMissions = this.pilot.pilotTotalMissions.find(pilot => pilot._id.license === pilot.license).missions;
          } else {
            this.pilot.pilotMissions = 0;
          }
          if (this.$store.state.stats.pilotHasAllMissions) {
            this.pilot.pilotTotalMissionsAll = this.$store.state.stats.pilotTotalMissionsAll;
            //this.pilot.pilotMissionsAll =  this.pilot.pilotTotalMissionsAll.find(pilot => pilot._id.license === pilot.license).missions;
          } else {
            this.pilot.pilotMissionsAll = 0;
          }
        } else {
          this.pilot.pilot_text = "No";
          this.pilot.licenseFile = "";
        }
        this.pilot.observer = pilot.observer;
        if (this.pilot.observer) {
          this.pilot.observer_text = "Yes";
        } else {
          this.pilot.observer_text = "No";
        }
        this.pilot.payloadOperator = pilot.payloadOperator;
        if (this.pilot.payloadOperator) {
          this.pilot.payloadOperator_text = "Yes";
        } else {
          this.pilot.payloadOperator_text = "No";
        }
        this.pilot.superuser = pilot.superuser;
        if (this.pilot.superuser) {
          this.pilot.superuser_text = "Yes";
        } else {
          this.pilot.superuser_text = "No";
        }
        this.selectedPilotTraining = this.pilotTraining.filter(
          pilot => pilot.license === pilot.license
        );
      } else {
        this.show_page_detail = false;
        this.pilot.licenseFile = "";
        this.pilot.pilotTotalMissionsAll = [];
        this.pilot.pilotTotalMissions = [];
      }
    },
    daysSince(datetime) {
      return parseInt(
        moment.duration(moment().diff(moment(datetime))).asDays()
      );
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    onPilotEmailChange() {
      var pilot = this.pilots[this.position];
      if (this.pilot.pilot && this.pilot.email != pilot.email) {
        swal.fire({
          title:
            this.$t("Please verify the email") +
            " " +
            this.pilot.email +
            " " +
            this.$t("is correct"),
          text: this.$t(
            "If you update pilot email, site surveys and other related reports will not be retrievable."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$t("Close"),
          buttonsStyling: false
        });
      }
    },
    onPilotCertificateChange() {
      var pilot = this.pilots[this.position];
      if (this.pilot.pilot && this.pilot.license != pilot.license) {
        swal.fire({
          title:
            this.$t("Please verify the number") +
            " " +
            this.pilot.license +
            " " +
            this.$t("is correct"),
          text: this.$t(
            "If you update certificate number, site surveys and other related reports will not be retrievable."
          ),
          type: "warning",
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$t("Close"),
          buttonsStyling: false
        });
      }
    },
    onPilotChange() {
      var pilot = this.pilots[this.position];
      if (
        (this.usertype === USER_TYPE.ENTERPRISE ||
          this.usertype === USER_TYPE.SUPER) &&
        this.pilot.pilot &&
        this.pilotQuantity >= this.quantity
      ) {
        swal
          .fire({
            title: this.$t("Reached subscription limit!"),
            text: this.$t("Please increase your subscription pilot quantity."),
            type: "warning",
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false
          })
          .then(() => {
            this.pilot.pilot = false;
          });
      } else if (
        (this.usertype === USER_TYPE.FREE ||
          this.usertype === USER_TYPE.PRO ||
          this.usertype === USER_TYPE.MAAC) &&
        this.pilot.pilot &&
        this.pilotQuantity >= 1
      ) {
        swal
          .fire({
            title: this.$t("Reached pilot limit!"),
            text: this.$t("Free or Pro account can only have one pilot."),
            type: "warning",
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false
          })
          .then(() => {
            this.pilot.pilot = false;
          });
      } else if (!this.pilot.pilot) {
        if (pilot.pilot && this.email != this.pilot.email) {
          swal.fire({
            title:
              this.$t("Please note the pilot account for") +
              " " +
              this.pilot.email +
              " " +
              this.$t("will be deactivated."),
            text: this.$t(
              "If you disable the pilot's role, the pilot account will be deactivated as well."
            ),
            type: "warning",
            confirmButtonClass: "md-button md-success",
            confirmButtonText: this.$t("Close"),
            buttonsStyling: false
          });
        }
        this.isPilotSel = true;
        this.isPilotLic = true;
      } else {
        this.isPilotSel = false;
        this.isPilotLic = false;
      }
    },
    onUploadLicense(e) {
      var self = this;
      const file = e.target.files[0];
      this.pilot.selectedFile = file.name;
      var fileReader = new FileReader();
      fileReader.onload = function(fileLoadedEvent) {
        var base64 = fileLoadedEvent.target.result;
        self.pilot.licenseData = base64.split(",")[1];
        self.pilot.fileType = file.type;
      };
      fileReader.readAsDataURL(file);
    },
    validate() {
      return this.$validator.validateAll().then(isValid => {
        if (!isValid) return;

        if (this.isNew) {
          this.addPilotValidated();
          if (this.errorMsg != "") {
            swal
              .fire({
                title: this.$t("Cannot create pilot account"),
                text:
                  this.$t(
                    "Please make sure the pilot's email is not used by an existing user account."
                  ) +
                  " " +
                  this.$t(this.errorMsg),
                type: "error",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              })
              .then(() => {
                this.errorMsg = "";
              });
          }
        } else {
          this.updatePilotValidated();
          if (this.errorMsg != "") {
            swal
              .fire({
                title: this.$t("Cannot create pilot account"),
                text:
                  this.$t(
                    "Please make sure the pilot's email is not used by an existing user account."
                  ) +
                  " " +
                  this.$t(this.errorMsg),
                type: "error",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              })
              .then(() => {
                this.errorMsg = "";
              });
          }
        }
      });
    },
    validateCertificateNumber() {
      var i;
      for (i = 0; i < this.pilots.length; i++) {
        var pilot = this.pilots[i];
        if (
          pilot.pilot &&
          pilot.license !== "" &&
          pilot.license == this.pilot.license
        ) {
          return false;
        }
      }
      return true;
    },
    showEditor(position) {
      this.editing = true;

      if (position !== null) {
        this.position = position;
        var pilot = this.pilots[position];
        this.isNew = false;
        this.isPilot = pilot.pilot;
        this.pilot.firstname = pilot.firstname;
        this.pilot.lastname = pilot.lastname;
        this.pilot.pilotname = pilot.firstname + " " + pilot.lastname;
        this.pilot.license = pilot.license;
        this.pilot.selectedFile = "";
        this.pilot.licenseType = pilot.licenseType;
        this.pilot.licenseData = null;
        this.pilot.licenseFile = pilot.licenseFile;
        this.pilot.phone = pilot.phone;
        this.pilot.email = pilot.email;
        this.pilot.pilot = pilot.pilot;
        this.pilot.threshold = pilot.threshold
          ? pilot.threshold
          : threshold_pilot_days;
        this.pilot.observer = pilot.observer;
        this.pilot.payloadOperator = pilot.payloadOperator;
        this.pilot.superuser = pilot.superuser;
        if (!this.pilot.pilot) {
          this.isPilotSel = true;
          this.isPilotLic = true;
        } else {
          this.isPilotSel = false;
          this.isPilotLic = false;
        }
      } else {
        this.isNew = true;
        this.isPilot = false;
        this.pilot.firstname = "";
        this.pilot.lastname = "";
        this.pilot.pilotname = "";
        this.pilot.license = "";
        this.pilot.selectedFile = "";
        this.pilot.licenseType = "";
        this.pilot.licenseData = null;
        this.pilot.licenseFile = "";
        this.pilot.phone = "";
        this.pilot.email = "";
        this.pilot.pilot = false;
        this.pilot.threshold = threshold_pilot_days;
        this.pilot.observer = false;
        this.pilot.payloadOperator = false;
        this.pilot.superuser = false;
        if (!this.pilot.pilot) {
          this.isPilotSel = true;
          this.isPilotLic = true;
        } else {
          this.isPilotSel = false;
          this.isPilotLic = false;
        }
      }
    },
    closeEditor(isUpdated) {
      this.editing = false;
      if (isUpdated) {
        console.log("not updated");
      } else {
        console.log("updated");
      }
    },
    showTrainingEditor(position) {
      if (
        this.usertype === USER_TYPE.ADMIN ||
        this.usertype === USER_TYPE.ENTERPRISE ||
        this.usertype === USER_TYPE.SUPER
      ) {
        this.editingTraining = true;
        this.position = position;
        var pilot = this.pilots[position];
        this.firstname = pilot.firstname;
        this.lastname = pilot.lastname;
        this.license = pilot.license;
      } else {
        swal
          .fire({
            title: this.$t(
              "This feature is only available for enterprise user"
            ),
            text: this.$t("Please contact us for more details."),
            type: "warning",
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false
          })
          .then(() => {
            this.closeTrainingEditor();
          });
      }
    },
    showTrainingEditorPilot(pilot) {
      if (
        this.usertype === USER_TYPE.ADMIN ||
        this.usertype === USER_TYPE.ENTERPRISE ||
        this.usertype === USER_TYPE.SUPER
      ) {
        this.editingTraining = true;
        this.firstname = pilot.firstname;
        this.lastname = pilot.lastname;
        this.license = pilot.license;
      } else {
        swal
          .fire({
            title: this.$t(
              "This feature is only available for enterprise user"
            ),
            text: this.$t("Please contact us for more details."),
            type: "warning",
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false
          })
          .then(() => {
            this.closeTrainingEditor();
          });
      }
    },
    closeTrainingEditor() {
      this.editingTraining = false;
      this.trainingDate = "";
      this.trainingDetails = "";
      this.showPageDetail(this.pilot, this.position);
      this.showTrainingHistory(this.pilot.license, this.position);
    },
    addPilotValidated() {
      var isValid = this.validateCertificateNumber();
      if (!isValid) {
        swal.fire({
          title: this.$t("The same license already exists!"),
          text: this.$t("Please check the license number."),
          type: "warning",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        return;
      }
      if (this.pilot.pilot) {
        swal
          .fire({
            title:
              this.$t("Please verify the number") +
              " " +
              this.pilot.license +
              " " +
              this.$t("is correct"),
            text: this.$t(
              "If you update certificate number, site surveys and other related reports will not be retrievable."
            ),
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "md-button md-success",
            cancelButtonClass: "md-button md-danger",
            confirmButtonText: this.$t("Yes"),
            cancelButtonText: this.$t("Cancel"),
            buttonsStyling: false
          })
          .then(result => {
            if (result.value) {
              this.$store
                .dispatch("setting/addPilot", {
                  position: this.position,
                  firstname: this.pilot.firstname,
                  lastname: this.pilot.lastname,
                  license: this.pilot.license,
                  licenseType: this.pilot.licenseType,
                  licenseData: this.pilot.licenseData,
                  licenseFile: this.pilot.licenseFile,
                  fileType: this.pilot.fileType,
                  phone: this.pilot.phone,
                  email: this.pilot.email,
                  pilot: this.pilot.pilot,
                  threshold: parseInt(this.pilot.threshold),
                  observer: this.pilot.observer,
                  payloadOperator: this.pilot.payloadOperator,
                  superuser: this.pilot.superuser
                })
                .then(() => {
                  if (this.errorMsg != "") {
                    swal
                      .fire({
                        title: this.$t("Cannot Add Pilot"),
                        text: this.$t(this.errorMsg),
                        type: "error",
                        confirmButtonClass: "md-button md-error",
                        buttonsStyling: false
                      })
                      .then(() => {
                        this.errorMsg = "";
                        this.editing = false;
                      });
                  } else {
                    this.editing = false;
                  }
                });
            }
          });
      } else {
        this.$store
          .dispatch("setting/addPilot", {
            position: this.position,
            firstname: this.pilot.firstname,
            lastname: this.pilot.lastname,
            license: this.pilot.license,
            licenseType: this.pilot.licenseType,
            licenseData: this.pilot.licenseData,
            licenseFile: this.pilot.licenseFile,
            fileType: this.pilot.fileType,
            phone: this.pilot.phone,
            email: this.pilot.email,
            pilot: this.pilot.pilot,
            observer: this.pilot.observer,
            payloadOperator: this.pilot.payloadOperator,
            superuser: this.pilot.superuser
          })
          .then(() => {
            if (this.errorMsg != "") {
              swal
                .fire({
                  title: this.$t("Cannot Add User"),
                  text: this.$t(this.errorMsg),
                  type: "error",
                  confirmButtonClass: "md-button md-error",
                  buttonsStyling: false
                })
                .then(() => {
                  this.errorMsg = "";
                  this.editing = false;
                });
            } else {
              this.editing = false;
            }
          });
      }
    },
    updatePilotValidated() {
      this.$store
        .dispatch("setting/updatePilot", {
          position: this.position,
          firstname: this.pilot.firstname,
          lastname: this.pilot.lastname,
          license: this.pilot.license,
          licenseType: this.pilot.licenseType,
          licenseData: this.pilot.licenseData,
          licenseFile: this.pilot.licenseFile,
          fileType: this.pilot.fileType,
          phone: this.pilot.phone,
          email: this.pilot.email,
          pilot: this.pilot.pilot,
          threshold: parseInt(this.pilot.threshold),
          observer: this.pilot.observer,
          payloadOperator: this.pilot.payloadOperator,
          superuser: this.pilot.superuser
        })
        .then(() => {
          if (this.errorMsg != "") {
            swal
              .fire({
                title: this.$t("Cannot Update User"),
                text: this.$t(this.errorMsg),
                type: "error",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              })
              .then(() => {
                this.errorMsg = "";
                this.editing = false;
              });
          } else {
            this.closeEditor(false);
            this.showTrainingHistory(this.pilot.license, this.position);
          }
        });
    },
    deletePilot() {
      if (this.pilot.pilot) {
        swal
          .fire({
            title: this.$t("Warning"),
            text: this.$t("Are you sure you want to delete the pilot?"),
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "md-button md-success",
            cancelButtonClass: "md-button md-danger",
            confirmButtonText: this.$t("Yes"),
            cancelButtonText: this.$t("Cancel"),
            buttonsStyling: false
          })
          .then(result => {
            if (result.value) {
              this.$store
                .dispatch("setting/deletePilot", { position: this.position })
                .then(() => {
                  this.editing = false;
                });
              this.showPageDetail(null, null);
            }
          });
      } else {
        this.$store
          .dispatch("setting/deletePilot", { position: this.position })
          .then(() => {
            this.editing = false;
          });
        this.showPageDetail(null, null);
      }
    },
    saveTraining() {
      this.$store
        .dispatch("setting/addPilotTraining", {
          license: this.license,
          timestamp: new Date(this.trainingDate).toISOString(),
          details: this.trainingDetails
        })
        .then(() => {
          this.closeTrainingEditor();
        });
    },
    showTrainingHistory(license, position) {
      this.selectedPosition = position;
      this.license = license;
      this.selectedPilotTraining = this.pilotTraining.filter(
        pilot => pilot.license === license
      );
    }
  },
  beforeMount() {
    this.$store.dispatch("stats/getPilotTotalMissionsAll");
    this.$store.dispatch("stats/getPilotTotalMissions");
    this.$store.dispatch("stats/getPilotTotalHours");
    this.$store.dispatch("stats/getPilotCurrentDays");
    this.$store.dispatch("setting/getPilotTraining");
    if (this.usertype === USER_TYPE.PILOT) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("Only administrator can access Pilot Setting page!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
  },
  mounted() {
    this.$store.dispatch("setting/getPilotTraining");
    this.$store.dispatch("stats/getPilotTotalMissionsAll");
    this.$store.dispatch("stats/getPilotTotalMissions");
    this.$store.dispatch("stats/getPilotTotalHours");

    EventBus.$on("getPilotTraining", () => {
      this.selectedPilotTraining = this.pilotTraining.filter(
        pilot =>
          this.selectedPosition >= 0 &&
          pilot.license === this.pilots[this.selectedPosition].license
      );
      console.log(this.selectedPilotTraining);
    });

    EventBus.$on("failedPilotAccess", msg => {
      this.errorMsg = msg;
    });
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    EventBus.$off("getPilotTraining");
    EventBus.$off("failedPilotAccess");
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>

<style lang="css">
.check {
  text-align: center;
}
.md-table-cell {
  font-size: 12px;
}
.paginated-table .md-table-head-label {
  font-size: 12px;
}
.md-table-head-label {
  font-size: 12px;
  padding-left: 0;
  padding-right: 10px;
  font-weight: 300;
  color: #333333;
}
</style>
